/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { FC } from "react";
import { BlockUI } from "./BlockUI";
import { NetworkRequestErrorAlert } from "./NetworkStatusAlert/NetworkRequestErrorAlert";

interface IContentWrapperComponent {
  blockLoading?: boolean;
  breadcrumb?: React.JSX.Element;
  footer?: React.JSX.Element;
  children: React.JSX.Element | React.JSX.Element[];
  alertBlock?: React.JSX.Element | React.JSX.Element[];
  isWorklist?: boolean;
  hasPadding?: boolean;
}

export const ContentWrapperComponent: FC<IContentWrapperComponent> = ({
  children,
  blockLoading = false,
  isWorklist = false,
  breadcrumb,
  footer,
  hasPadding = true,
  alertBlock,
}) => {
  return (
    <div className="content-wrapper">
      {breadcrumb}
      <div
        className={`content ${hasPadding ? "" : "p-none"} ${
          isWorklist ? "worklist-content" : ""
        }`}
        id="main-content"
      >
        <NetworkRequestErrorAlert />
        {alertBlock}
        <BlockUI isBlocked={blockLoading}>{children}</BlockUI>
      </div>
      {footer}
    </div>
  );
};
